/* DTF STL home page sections: category rail + before/after slider. Re-runs when the theme editor reloads a section. */
(function () {
  function initRail(section) {
    var rail = section.querySelector('.rail'), dots = section.querySelector('.rail__dots');
    if (!rail || rail.dataset.ready) return;
    rail.dataset.ready = '1';
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = Number(rail.dataset.auto || 0);
    function pageW() { return rail.clientWidth; }
    function pages() { return Math.max(1, Math.ceil((rail.scrollWidth - 2) / pageW())); }
    function mark() {
      if (!dots) return;
      var max = rail.scrollWidth - pageW();
      var idx = max <= 0 ? 0 : Math.round(rail.scrollLeft / max * (pages() - 1));
      [].forEach.call(dots.children, function (d, i) { d.classList.toggle('on', i === idx); });
    }
    function build() {
      if (!dots) return;
      dots.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to page ' + (i + 1));
        (function (n) { b.onclick = function () { rail.scrollTo({ left: n * pageW(), behavior: 'smooth' }); }; })(i);
        dots.appendChild(b);
      }
      mark();
    }
    function go(dir) {
      var max = rail.scrollWidth - pageW(), next = rail.scrollLeft + dir * pageW();
      if (next > max + 4) next = 0;
      if (next < -4) next = max;
      rail.scrollTo({ left: next, behavior: 'smooth' });
    }
    section.querySelectorAll('[data-rail]').forEach(function (btn) { btn.onclick = function () { go(Number(btn.dataset.rail)); }; });
    rail.addEventListener('scroll', mark, { passive: true });
    addEventListener('resize', build);
    build();
    if (auto > 0 && !reduce) {
      var paused = false;
      rail.addEventListener('mouseenter', function () { paused = true; });
      rail.addEventListener('mouseleave', function () { paused = false; });
      rail.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      setInterval(function () { if (!paused && !document.hidden) go(1); }, auto);
    }
  }
  function initCompare(section) {
    section.querySelectorAll('.compare').forEach(function (el) {
      var input = el.querySelector('input');
      if (!input || input.dataset.ready) return;
      input.dataset.ready = '1';
      input.addEventListener('input', function () { el.style.setProperty('--pos', input.value + '%'); });
    });
  }
  function init(root) {
    (root || document).querySelectorAll('.dtf').forEach(function (s) { initRail(s); initCompare(s); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
